"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderMetadataType = exports.OrderDetailsPaymentIntegrationType = exports.OrderServiceTime = exports.OrderFromType = exports.ServiceTimeKindType = exports.OrderPaymentStatus = exports.OrderSource = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    /** The not refunded status. */
    OrderStatus[OrderStatus["NotRefunded"] = 0] = "NotRefunded";
    /** The partly refunded status, meaning one of several payments/items have been refunded. */
    OrderStatus[OrderStatus["PartlyRefunded"] = 1] = "PartlyRefunded";
    /** The refunded status, the status become refunded when all connected payments/items are refunded. */
    OrderStatus[OrderStatus["Refunded"] = 2] = "Refunded";
    /** Refund is still pending. Status will be updated later. */
    OrderStatus[OrderStatus["RefundPending"] = 3] = "RefundPending";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
/**
 * @deprecated Use StaticSaleSourceID instead
 */
var OrderSource;
(function (OrderSource) {
    OrderSource["OrderWeb"] = "orderweb";
    OrderSource["OrderApp"] = "orderapp";
    OrderSource["Express"] = "expressclient";
    OrderSource["PosClient"] = "posclient";
    OrderSource["Deliverect"] = "deliverect";
})(OrderSource = exports.OrderSource || (exports.OrderSource = {}));
var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus[OrderPaymentStatus["Completed"] = 0] = "Completed";
    OrderPaymentStatus[OrderPaymentStatus["RefundPending"] = 1] = "RefundPending";
    OrderPaymentStatus[OrderPaymentStatus["Refunded"] = 2] = "Refunded";
    OrderPaymentStatus[OrderPaymentStatus["Error"] = 3] = "Error";
    OrderPaymentStatus[OrderPaymentStatus["PartlyRefunded"] = 4] = "PartlyRefunded";
})(OrderPaymentStatus = exports.OrderPaymentStatus || (exports.OrderPaymentStatus = {}));
var ServiceTimeKindType;
(function (ServiceTimeKindType) {
    ServiceTimeKindType[ServiceTimeKindType["AsSoonAsPossible"] = 0] = "AsSoonAsPossible";
    ServiceTimeKindType[ServiceTimeKindType["AtSpecifiedTime"] = 1] = "AtSpecifiedTime";
})(ServiceTimeKindType = exports.ServiceTimeKindType || (exports.ServiceTimeKindType = {}));
var OrderFromType;
(function (OrderFromType) {
    OrderFromType[OrderFromType["Checkout"] = 0] = "Checkout";
    OrderFromType[OrderFromType["Check"] = 1] = "Check";
})(OrderFromType = exports.OrderFromType || (exports.OrderFromType = {}));
var OrderServiceTime;
(function (OrderServiceTime) {
    OrderServiceTime[OrderServiceTime["now"] = 0] = "now";
    OrderServiceTime[OrderServiceTime["specificTime"] = 1] = "specificTime";
})(OrderServiceTime = exports.OrderServiceTime || (exports.OrderServiceTime = {}));
var OrderDetailsPaymentIntegrationType;
(function (OrderDetailsPaymentIntegrationType) {
    OrderDetailsPaymentIntegrationType[OrderDetailsPaymentIntegrationType["AdyenECOM"] = 1] = "AdyenECOM";
    OrderDetailsPaymentIntegrationType[OrderDetailsPaymentIntegrationType["AdyenPOS"] = 2] = "AdyenPOS";
})(OrderDetailsPaymentIntegrationType = exports.OrderDetailsPaymentIntegrationType || (exports.OrderDetailsPaymentIntegrationType = {}));
var OrderMetadataType;
(function (OrderMetadataType) {
    OrderMetadataType["TapToPay"] = "TapToPay";
})(OrderMetadataType = exports.OrderMetadataType || (exports.OrderMetadataType = {}));
